<template>
	<TeamingDropDown class="grouped-dropdown"
		:disabled="disabled"
		:options="options"
		:value="value"
		:alt-value-field="altValueField"
		:width="width"
		:is-valid="isValid"
	>
		<template #selected>
			<div class="selected-text">
				{{ selectedOption.text }}
			</div>
		</template>

		<template #options="{ option, onOptionClicked }">
			<div v-if="option.group" class="option-group">
				<div class="option-group-name">{{ option.group }}</div>
				<ul class="sub-options">
					<li v-for="subOption in option.options"
						:key="subOption[ altValueField ? altValueField : `value` ]"
					>
						<DropDownRow
							:option="subOption"
							:is-selected="subOption.value === selectedOption.value"
							@click="onOptionClicked( subOption, $event )"
						/>
					</li>
				</ul>
			</div>
			<DropDownRow
				v-else
				:option="option"
				:is-selected="option.value === selectedOption.value"
				@click="onOptionClicked( option, $event )"
			/>
		</template>
	</TeamingDropDown>
</template>

<script>
import DropDownRow from "./DropDownRow.vue";
import TeamingDropDown from "./TeamingDropDown.vue";

export default {
	name: "TeamingGroupedDropDown",
	components: {
		DropDownRow,
		TeamingDropDown,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		/** [ { text:String, value:String, |group:String, options:Array, isPlaceholder:Boolean| }, ... ] */
		options: {
			type: Array,
			required: true,
		},
		value: {
			type: String,
			default: "",
		},
		altValueField: {
			type: String,
			default: "",
		},
		width: {
			type: String,
			default: "",
		},
		isValid: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {};
	},
	computed: {
		valueField() {
			return this.altValueField || "value";
		},
		selectableOptions() {
			return this.options.filter( option => !option.isPlaceholder );
		},
		flattenedOptions() {
			return this.selectableOptions.reduce( ( acc, option ) => {
				return [
					...acc,
					...( option.options ? option.options : [ option, ] ),
				];
			}, [] );
		},
		selectedOption() {
			const { flattenedOptions, value, valueField, } = this;

			return flattenedOptions.find( option => option[ valueField ] === value ) ||
				flattenedOptions[ 0 ] ||
				{
					text: "",
					[ valueField ]: "",
				};
		},
	},
};
</script>

<style lang="scss" scoped>
$fontColor: $color1-700;
$backgroundColor: $white;
$groupNameColor: $color2-500;

.grouped-dropdown .option-group-name {
	padding: 0 0.5rem;
	@include font-and-line-for(-1);
	font-weight: 600;
	text-transform: uppercase;
	color: $groupNameColor;
}

.grouped-dropdown .sub-options {
	list-style: none;
	margin: 0.4rem 0;
	padding: 0;
	background-color: $backgroundColor;
	text-align: left;
	color: $fontColor;
	cursor: pointer;

	display: flex;
	flex-direction: column;
	gap: 0.4rem;
}

.grouped-dropdown .selected-text {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	text-align: left;
}
</style>
